import {
  faEnvelopeOpenText,
  faMagicWandSparkles,
  faTableColumns,
} from '@fortawesome/free-solid-svg-icons';

import {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalSection,
} from 'apps/shared/scripts/components';

import ListItem from './ListItem';
import {
  headingClassName,
  linkClassName,
  listClassName,
  subheadingClassName,
} from './styles';

interface Props {
  onBack: () => void;
  onCancel: () => void;
  onGuest: () => void;
  onJoin: () => void;
  onLogin: () => void;
}

const AuthPrompt = ({ onBack, onCancel, onGuest, onJoin, onLogin }: Props) => {
  return (
    <>
      <ModalHeader onBack={onBack} onDismiss={onCancel} title={'Sign Up'} />
      <ModalBody>
        <ModalSection>
          <h4 className={headingClassName}>
            Already have an account?{' '}
            <span className={linkClassName} role="button" onClick={onLogin}>
              Log in
            </span>
          </h4>
          <h4 className={subheadingClassName}>
            Create a free profile in less than 1 min to enjoy these benefits:
          </h4>
          <div className={listClassName}>
            <ListItem
              icon={faMagicWandSparkles}
              title="Edit Posts"
              subtitle="Update messages anytime after posting them."
            />
            <ListItem
              icon={faTableColumns}
              title="Manage Cards"
              subtitle="Easily track and view all cards that you've signed."
            />
            <ListItem
              icon={faEnvelopeOpenText}
              title="Create Cards"
              subtitle="Organize and send cards to anyone around the world."
            />
          </div>
        </ModalSection>
      </ModalBody>
      <ModalFooter
        onCancel={onGuest}
        onSubmit={onJoin}
        primaryCtaLabel={'Join'}
        secondaryCtaLabel={'Continue as Guest'}
      />
    </>
  );
};

AuthPrompt.displayName = 'AuthPrompt';

export default AuthPrompt;
